<template>
  <error-component v-bind="$attrs" v-slot="{touch, faulty}">
    <div class="flex flex-col items-stretch" :class="{'faulty-composite': faulty}">
      <card type="round-no-pad">
        <div class="flex-col flex">
          <check-button class="border-b border-line" :simple="true" :radio="v" :value="value" v-for="[v, label] of radioOptions" :key="v" @input="touch(); $emit('input', v)">{{label}}</check-button>
        </div>
        <div v-if="showOptions">
          <select-input
            :options="hiddenOptions"
            :placeholder="otherPlaceholder"
            :value="value"
            :multipart="true"
            @input="touch(); $emit('input', $event)"
          />
        </div>
      </card>
    </div>
  </error-component>
</template>

<script>
import ErrorComponent from "@/components/ErrorComponent";
import SelectInput from "@/components/SelectInput";
import CheckButton from "@/components/CheckButton";

export default {
  props: {
    value: String,
    options: Object,
    showOptions: Number,
    otherPlaceholder: String
  },
  computed: {
    radioOptions() {
      if(this.showOptions) {
        return Object.entries(this.options).slice(0, this.showOptions)
      } else {
        return Object.entries(this.options)
      }
    },
    hiddenOptions() {
      return Object.fromEntries(Object.entries(this.options).slice(this.showOptions))
    }
  },
  components: {
    ErrorComponent,
    SelectInput,
    CheckButton
  }
}
</script>

<style>

</style>